export const AcreageOptions = [
  { label: '0 - 0.50 acres', value: '0,0.50' },
  { label: '0.51 - 1.00 acres', value: '0.51,1.00' },
  { label: '1.01 - 1.50 acres', value: '1.01,1.50' },
  { label: '1.51 - 2.00 acres', value: '1.51,2.00' },
  { label: '+2.01 acres', value: '2.01' },
]
